import { moduleNames } from '../../constants';

export const isMarketDynamics = module => module === moduleNames.marketDynamics;
